// Helpers
import { getCellClassNameFn } from "@/Common/helpers/Tables";
// Components
import { ExpandCollapseAllButtonHeader } from "@Layouts/components/TreeGrid/ExpandCollapseAllButtonHeader";
import { CustomGridTreeDataGroupingCell } from "@Layouts/components/TreeGrid/CustomGridTreeDataGroupingCell";
// Types
import { GridGroupingColDefOverride } from "@mui/x-data-grid-pro";
import { CustomGridTreeDataGroupingCellProps, IExpandCollapseAllButtonHeader } from "@Layouts/components/types";

export function prepareGroupColDef(props?: Readonly<IExpandCollapseAllButtonHeader>): GridGroupingColDefOverride {
	return {
		headerName: "",
		width: 32,
		minWidth: 32,
		maxWidth: 32,
		resizable: false,
		sortable: false,
		headerClassName: "[&_*]:!overflow-visible",
		renderHeader: () => <ExpandCollapseAllButtonHeader expandedAll {...props} />,
		cellClassName: getCellClassNameFn(),
		renderCell: (params) => (
			<CustomGridTreeDataGroupingCell
				{...(params as CustomGridTreeDataGroupingCellProps)}
				className="size-[20px] relative -left-[3px] -top-[1px]"
			/>
		),
		// Setting this prevents the grouping column from being taken into account when doing quick search
		// Sonar encourages to use "null" instead but MUI requires it to be "undefined" to work
		getApplyQuickFilterFn: undefined, //NOSONAR
	};
}
